import Route from '@ember/routing/route';

export default class AppServicesWaldenGreenReportRoute extends Route {}
